import React, {useRef} from 'react';
import { Chart } from 'primereact/chart';
import { BreadCrumb } from 'primereact/breadcrumb';
import {sample_questionnaire} from "../../utils/common";
import { RadioButton } from 'primereact/radiobutton';
import { ToggleButton } from 'primereact/togglebutton';
// import 'chartjs-plugin-labels';

export default function SubmitScreen(){

    const chartRef = useRef()

    const colors = [
      "#D57F00",
      "#19988B",
      "#008542",
      "#005E86",
      "#ABAD25",
    ]

    const chartData = {
      labels: ['Stocks', 'Bonds', 'Stocks 1', "Stocks 2", "Others"],
      datasets: [
        {
          data: [10, 25, 20, 15, 30],
          backgroundColor: colors
        }
      ]
    };
    
  //   const basicData = {
  //     // labels: ['Result Type'],
  //     datasets: [
  //         {
  //             label: 'Stocks',
  //             backgroundColor: colors[0],
  //             data: [7]
  //         },
  //         {
  //             label: 'Bonds',
  //             backgroundColor: colors[1],
  //             data: [5]
  //         },
  //         {
  //             label: 'Stocks 1',
  //             backgroundColor: colors[2],
  //             data: [3]
  //         },
  //         {
  //             label: 'Stocks 2',
  //             backgroundColor: colors[3],
  //             data: [4]
  //         },
  //         {
  //             label: 'Others',
  //             backgroundColor: colors[4],
  //             data: [3]
  //         }
  //     ]
  // };

    const stackedData = {
      labels: ['0-10%','10-20%', '20-30%', '30-40%', '40-100%',],
      datasets: [{
          type: 'bar',
          label: 'Stocks',
          backgroundColor: colors[0],
          data: [3, 2, 3, 0, 1]
      }, {
          type: 'bar',
          label: 'Bonds',
          backgroundColor: colors[1],
          data: [2, 1, 1, 1, 2]
      }, {
          type: 'bar',
          label: 'Stocks 1',
          backgroundColor: colors[2],
          data: [2, 0, 1, 1, 2]
      }, {
        type: 'bar',
        label: 'Stocks 3',
        backgroundColor: colors[3],
        data: [1, 4, 1, 1, 0]
      }, {
        type: 'bar',
        label: 'Others',
        backgroundColor: colors[4],
        data: [1, 2, 0, 1, 3]
      }
    ]
    };

    let stackedOptions = (stack, xlabel, ylabel) => ({
      plugins : {
        labels : {
          render : () => {}
        }
      },
      animation : {
        duration: 1,
      },
      tooltips: {
          mode: 'index',
          intersect: false
      },
      responsive: true,
      scales: {
          xAxes: [{
              barPercentage : 0.75,
              scaleLabel : {
                  display : true,
                  labelString : xlabel,
                  fontColor : "#cccccc",
                  fontStyle: "bold",
                  fontSize : 16,
              },
              stacked: stack,
              ticks: {
                  fontColor: '#cccccc'
              },
              gridLines: {
                  color: '#666666'
              }
          }],
          yAxes: [{
              scaleLabel : {
                display : true,
                labelString : ylabel,
                fontColor : "#cccccc",
                fontSize : 16,
                fontStyle: "bold"
              },
              stacked: stack,
              ticks: {
                  autoSkip : true,
                  maxTicksLimit : 6,
                  fontColor: '#cccccc',
                  beginAtZero : true
              },
              gridLines: {
                  color: '#666666'
              }
          }]
      },
      legend: {
          labels: {
              fontColor: '#cccccc'
          }
      }
    });

    const [questionnaire, setQuestionnaire] = React.useState(sample_questionnaire)

    const lightOptions = {
      plugins : {
        labels : {
          render : 'percentage',
          fontColor : "#eeeeee",
          precision : 2,
          fontSize : 18,
          fontStyle:"bold"
        },
      },
      responsive: true,
      maintainAspectRatio: true,
      // pieceLabel :{
      //   mode : 'percentage',
      //   fontSize: 18,
      //   precision: 2,
      //   fontColor: '#fff',
      // },
      elements : {
        arc : {
          borderWidth : 0
        }
      },
      legend: {
        labels: {
          fontColor: '#cccccc'
        }
      },
      animation : {
        duration: 1,
        // onComplete : drawSegmentValues
      },
      tooltips : {
        callbacks : {
          label : (tooltipItem, data) => {
            // return data['datasets'][0]['data'][tooltipItem['index']] + "%"
            return data['labels'][tooltipItem['index']] + ": " + data['datasets'][0]['data'][tooltipItem['index']] + "%"
          }
        },
        
      }
    };

    const items = [
      { label: "Risk Assessment", url: "/Questionnaires" },
      { label:  "Result of the Risk Assessment" },
    ];

    const home = {
      icon: "pi pi-home",
      url: "/",
    };

    const [showQuestions, setShowQuestions] = React.useState(false);

    React.useEffect(() => {
      var questions = [...sample_questionnaire.questions]
      questions[0].optionText = "2 years or less"
      questions[1].optionText = "More than 15 years"
      questions[2].optionText = "6-10 years"

      setQuestionnaire({...sample_questionnaire, questions : questions})
    }, []);

    const radioButtonStyles = (color) => ({
      color : "blue",
      "p-radiobutton-box.p-highlight" : {
          borderColor : color
      }
    })

    return (
        <div className="main-box app__grid">
          <BreadCrumb model={items} home={home} style={{marginBottom:"20px"}}/>
          <h2>{sample_questionnaire.title} Result</h2>

          <div className="app__grid">
            <div className="col-6">
              <Chart ref={chartRef} type="pie" data={chartData} options={lightOptions}/>
            </div>
            {/* <div className="col-1"></div> */}
            <div className="col-6">
              <Chart type="bar" data={stackedData} options={stackedOptions(true, "Question weightage", "Number of Questions")} />
              {/* <Chart type="bar" data={basicData} options={stackedOptions(false, "Result Type", "Number of Questions")} /> */}
            </div>
          </div>

          <div className="flex justify-content-center">
            <ToggleButton
              onLabel = "Hide Assesment Result"
              offLabel = "Show Assesment Result"
              onIcon = "pi pi-angle-up"
              offIcon = "pi pi-angle-down"
              checked = {showQuestions}
              onChange = {(e) => setShowQuestions(e.value)}
              iconPos = "right"
              // onClick={() => setShowQuestions(prev => (1-prev))}
              // label={showQuestions ? "View less" : "View more"}
              className="diag-save-button mt-6 mb-6 "
            />
          </div>
          
          {
            showQuestions ?
            questionnaire.questions.map((question, index) => {
              const item=question
              return (
                <div className="pb-4" key={index}>
                  <div className="box flex justify-content-between">
                    <div style={{fontWeight : 650}}><span style={{fontWeight:800}}>Q{index + 1}. </span>{item.questionText}</div>
                    <div style={{fontWeight:"bold"}}>33.3%</div>
                  </div>
                  
                  <div className="grid pl-2 pt-3">
                  {
                    question.options.map((item, index) => 
                      <div 
                        className="radioDiv col-12 md:col-6 lg:col-4" key={index} 
                        style={{color : question.optionText === item.optionText ? colors[index] : "#ffffff"}}
                      >
                        <RadioButton disabled = {question.optionText === item.optionText ? false : true} style={radioButtonStyles(colors[index])} value = {item.optionText} inputId={item.optionText + index} name={item.optionText} checked={question.optionText === item.optionText}/>
                        <label style={{marginLeft : "0.5rem"}} htmlFor={item.optionText}>{item.optionText}</label>
                      </div>
                    )
                  }
                  </div>
                </div>
              )
            })
            : <div></div>
          }
        </div>
    )
}
